import { formatIDR } from "@/lib/constants";

/** Donut SATU metrik progress pembayaran (spec 2026-06-20, user request).
 *  Menerima metrik dari `computePaymentProgress` (lib/paymentProgress) —
 *  persentase & sisa SELALU dari denominator yang sama (tidak dicampur).
 *  - basisLabel null → tampil "Belum ada dasar perhitungan" (bukan 0%).
 *  - Tanpa clamp: penerimaan melebihi dasar → persentase sebenarnya + warning
 *    "Penerimaan melebihi dasar". Arc visual tetap dibatasi 100%.
 *  Dipakai bersama oleh RingkasanTab (monitoring), CashFlowTab, dan
 *  finance-report/RingkasanTab. */
export default function PaymentDonut({
  pct, received, remaining, basisLabel, over = false,
  receivedLabel = "Sudah Diterima", remainingLabel,
  emptyText = "Belum ada dasar perhitungan", testid = "payment-donut",
}) {
  const R = 52, C = 2 * Math.PI * R;
  const hasBasis = pct != null;
  const arcPct = hasBasis ? Math.min(100, Math.max(0, pct)) : 0;
  const dash = (arcPct / 100) * C;
  return (
    <div className="flex items-center gap-4" data-testid={testid}>
      <svg width="140" height="140" viewBox="0 0 140 140" className="shrink-0">
        <circle cx="70" cy="70" r={R} fill="none" stroke="#E2E8F0" strokeWidth="14" />
        {hasBasis && (
          <circle cx="70" cy="70" r={R} fill="none" stroke={over ? "#D97706" : "#059669"} strokeWidth="14" strokeLinecap="round"
            strokeDasharray={`${dash} ${C - dash}`} strokeDashoffset={C / 4} transform="rotate(-90 70 70)" />
        )}
        <text x="70" y="76" textAnchor="middle" className={hasBasis ? (over ? "fill-amber-700" : "fill-[#0B1D3A]") : "fill-slate-400"} fontSize={hasBasis ? 22 : 12} fontWeight="700" data-testid={`${testid}-pct`}>
          {hasBasis ? `${Math.round(pct)}%` : "—"}
        </text>
      </svg>
      <div className="text-xs space-y-1.5">
        {!hasBasis ? (
          <div className="text-slate-500 italic" data-testid={`${testid}-empty`}>{emptyText}</div>
        ) : (
          <>
            <div className="flex items-center gap-2"><span className={`w-2 h-2 inline-block ${over ? "bg-amber-600" : "bg-emerald-600"}`} /> {receivedLabel}
              <span className={`font-semibold tabular-nums ml-1 ${over ? "text-amber-700" : "text-emerald-700"}`}>{formatIDR(received)}</span></div>
            <div className="flex items-center gap-2"><span className="w-2 h-2 bg-slate-300 inline-block" /> {remainingLabel || `Sisa terhadap ${basisLabel}`}
              <span className={`font-semibold tabular-nums ml-1 ${over ? "text-amber-700" : "text-slate-700"}`} data-testid={`${testid}-remaining`}>{formatIDR(remaining)}</span></div>
            {over && (
              <div className="text-[10px] font-semibold text-amber-700 bg-amber-50 border border-amber-200 px-1.5 py-0.5" data-testid={`${testid}-over-warning`}>
                Penerimaan melebihi dasar ({basisLabel})
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
